import React from 'react'
import styled from '@emotion/styled'

import SEO from '~/components/seo'
import Blog from '~/components/Blog'

import { breakpoints } from '~/utils/styles'

const BlogPage = () => {
  return (
    <>
      <SEO title="About" />
      <Padding>
        <Blog limit={20} />
      </Padding>
    </>
  )
}

export default BlogPage

const Padding = styled.div`
  padding-top: 100px;

  @media (max-width: ${breakpoints.s}px) {
    padding-top: 50px 0 !important;
  }
`
